// UTM Tracking Utilities
export class UTMUtil {
  private static readonly UTM_SOURCE_KEY = 'utm_source';
  private static readonly REF_KEY = 'ref';
  private static readonly COOKIE_EXPIRY_DAYS = 30;

  /**
   * Capture UTM parameters from URL and store in cookies
   */
  static captureUTMParams(): void {
    if (typeof window === 'undefined') return;

    const urlParams = new URLSearchParams(window.location.search);
    
    // Capture utm_source
    const utmSource = urlParams.get('utm_source');
    if (utmSource) {
      this.setCookie(this.UTM_SOURCE_KEY, utmSource, this.COOKIE_EXPIRY_DAYS);
    }

    // Capture ref
    const ref = urlParams.get('ref');
    if (ref) {
      this.setCookie(this.REF_KEY, ref, this.COOKIE_EXPIRY_DAYS);
    }
  }

  /**
   * Get stored UTM parameters from cookies
   */
  static getStoredUTMParams(): { utmSource?: string; ref?: string } {
    if (typeof window === 'undefined') {
      return {};
    }

    return {
      utmSource: this.getCookie(this.UTM_SOURCE_KEY),
      ref: this.getCookie(this.REF_KEY),
    };
  }

  /**
   * Get UTM parameters for API requests
   */
  static getUTMForAPI(): { utmSource: string; ref: string } {
    const params = this.getStoredUTMParams();
    return {
      utmSource: params.utmSource || '',
      ref: params.ref || '',
    };
  }

  /**
   * Set cookie with expiration
   */
  private static setCookie(name: string, value: string, days: number): void {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  }

  /**
   * Get cookie value by name
   */
  private static getCookie(name: string): string | undefined {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length));
      }
    }
    return undefined;
  }

  /**
   * Clear all UTM cookies
   */
  static clearUTMCookies(): void {
    this.setCookie(this.UTM_SOURCE_KEY, '', -1);
    this.setCookie(this.REF_KEY, '', -1);
  }
}
